import React from 'react';

const ContactPage = () => {
  return (
    <div className="bg-background text-on-surface font-body antialiased min-h-screen pt-24 pb-20">
      <main className="max-w-4xl mx-auto px-8">
        <header className="mb-20 text-center">
          <span className="text-primary font-bold tracking-widest uppercase text-sm mb-4 block">Get in Touch</span>
          <h1 className="text-5xl md:text-6xl font-extrabold tracking-tighter mb-8 font-headline">
            We'd love to <span className="text-primary italic">hear from you</span>.
          </h1>
          <p className="text-xl text-on-surface-variant max-w-2xl mx-auto">
            Whether you have a recommendation for a hidden gem or need help with a listing, our curation team is here to assist.
          </p>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
          <section className="space-y-12">
            <div>
              <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-primary mb-6">Our Office</h3>
              <p className="text-lg text-on-surface-variant leading-relaxed">
                Calea Victoriei 120,<br/>
                Sector 1, Bucharest<br/>
                Romania
              </p>
            </div>
            <div>
              <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-primary mb-6">General Inquiries</h3>
              <p className="text-lg text-on-surface-variant leading-relaxed">
                hello@localadvisor.ro<br/>
                +40 123 456 789
              </p>
            </div>
          </section>

          <section className="bg-surface-container-low p-10 rounded-3xl shadow-sm border border-outline-variant/10">
            <form className="space-y-6">
              <div className="space-y-2">
                <label className="text-xs font-bold uppercase tracking-widest text-on-surface-variant">Name</label>
                <input type="text" className="w-full bg-white border-none rounded-xl p-4 focus:ring-2 focus:ring-primary/20" placeholder="Your name" />
              </div>
              <div className="space-y-2">
                <label className="text-xs font-bold uppercase tracking-widest text-on-surface-variant">Email</label>
                <input type="email" className="w-full bg-white border-none rounded-xl p-4 focus:ring-2 focus:ring-primary/20" placeholder="your@email.com" />
              </div>
              <div className="space-y-2">
                <label className="text-xs font-bold uppercase tracking-widest text-on-surface-variant">Message</label>
                <textarea rows="4" className="w-full bg-white border-none rounded-xl p-4 focus:ring-2 focus:ring-primary/20" placeholder="How can we help?"></textarea>
              </div>
              <button className="w-full bg-primary text-on-primary py-4 rounded-full font-bold hover:opacity-90 transition-all active:scale-95 shadow-xl shadow-primary/20">
                Send Message
              </button>
            </form>
          </section>
        </div>
      </main>
    </div>
  );
};

export default ContactPage;
